import { z } from "zod";
import type { TSelector } from "../../../i18n/types";

export const sponsoredAdsAudienceGroupingSchema = z.enum(["segment_name", "segment_name,campaign_id"]);

export type SponsoredAdsAudienceGrouping = z.infer<typeof sponsoredAdsAudienceGroupingSchema>;

export const sponsoredAdsAudienceAdTypeSchema = z.enum(["sponsoredProduct", "sponsoredBrand"]);

export type SponsoredAdsAudienceAdType = z.infer<typeof sponsoredAdsAudienceAdTypeSchema>;

type LabeledOption<V> = { label: TSelector; value: V };

export const SPONSORED_ADS_AUDIENCE_GROUPING_OPTIONS: ReadonlyArray<LabeledOption<SponsoredAdsAudienceGrouping>> = [
  { label: ($) => $.perf_reports["By Audience Segment"], value: "segment_name" },
  { label: ($) => $.perf_reports["By Audience Segment and Campaign"], value: "segment_name,campaign_id" },
] as const;

export const SPONSORED_ADS_AUDIENCE_AD_TYPE_OPTIONS: ReadonlyArray<LabeledOption<SponsoredAdsAudienceAdType>> = [
  { label: ($) => $.perf_reports["Sponsored Product"], value: "sponsoredProduct" },
  { label: ($) => $.perf_reports["Sponsored Brand"], value: "sponsoredBrand" },
] as const;
